import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Group } from '@app/tool/model/group.model';
import { Tool } from '@app/tool/model/tool.model';
import { ToolSet } from '@app/tool/model/toolSet.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-maintenance-plan-tools-table',
  templateUrl: './maintenance-plan-tools-table.component.html',
  styleUrls: ['./maintenance-plan-tools-table.component.scss']
})
export class MaintenancePlanToolsTableComponent implements OnInit {
  @Input() tools = new Array<Group>();
  @Input() selectedTools = new Array<Tool | ToolSet>();
  @Input() tableConfig: TableConfig;
  @Input() isLoading = false;
  @Input() showFilters = true;
  @Input() showGroupFilters = false;
  @Input() showGroupers = false;
  @Input() isFilterExpanded = false;
  @Input() definedGroupers = false;
  @Input() showPagination = true;
  @Input() filtersToggle = true;
  @Input() toolsGrouped = new Array<Group>();
  @Input() readonly = false;  

  @Output() pageChange = new EventEmitter<any>();
  @Output() filterChange = new EventEmitter<any>();
  @Output() filterGroupChange = new EventEmitter<any>();
  @Output() groupChange = new EventEmitter<any>();
  @Output() sortChange = new EventEmitter<any>();
  @Output() onToolClicked = new EventEmitter<{ checked: boolean, group: Tool | ToolSet }>();

  groupableColumns = [];
  groupFilters = [];

  constructor(private translateService: TranslateService) {
      this.groupFilters = this.buildGroupFilters();
      this.groupableColumns = this.buildGroupableColumnKeys();
      this.translateService.onLangChange.subscribe((event) => {
          this.groupFilters = this.buildGroupFilters();
          this.rebuildAllOptionForGroupFilter();
          this.groupableColumns = this.buildGroupableColumnKeys();
      });
  }
  ngOnInit() {}

  buildGroupFilters(items = [], id = -1) {
      return [
          {
              id: 0,
              placeholder: this.translateService.instant("admin.tools.table.grouping.options.equipment"),
              items: id === 0 && items.length > 0 ? items : ((this.groupFilters.length > 0 && this.groupFilters[0].items) || []),
              displayField: 'name',
              value: "id",
              filterParam: "equipmentId",
              selectedValue: (this.groupFilters.length > 0 && this.groupFilters[0].selectedValue) ?
                  this.groupFilters[0].selectedValue : '',
          },
          {
              id: 1,
              placeholder: this.translateService.instant("admin.tools.table.grouping.options.partNumber"),
              items: id === 1 && items.length > 0 ? items : ((this.groupFilters.length > 1 && this.groupFilters[1].items) || []),
              displayField: 'name',
              value: "id",
              filterParam: "partNumberId",
              selectedValue: (this.groupFilters.length > 1 && this.groupFilters[1].selectedValue) ?
                  this.groupFilters[1].selectedValue : '',
          },
      ];
  }

  buildGroupableColumnKeys() {
      return [
          {
              id: 0,
              name: this.translateService.instant("admin.tools.table.grouping.options.equipment"),
              value: "Equipment"
          },
          {
              id: 1,
              name: this.translateService.instant("admin.tools.table.grouping.options.partNumber"),
              value: "PartNumber"
          }
      ];
  }

  private addAllOptionForSelect(response, itemsName) {
      response[itemsName].unshift({
          id: 0,
          name: this.translateService.instant('lineSetter.toolRequest.table.groupFilter.all.' + itemsName)
      });
      response.total++;
      return response;
  }

  private rebuildAllOptionForGroupFilter() {
      if (this.groupFilters.length > 0 && this.groupFilters[0].items.length > 0) {
          this.groupFilters[0].items[0].name = this.translateService.instant(
              'lineSetter.toolRequest.table.groupFilter.all.equipment');
      }
      if (this.groupFilters.length > 1 && this.groupFilters[1].items.length > 0) {
          this.groupFilters[1].items[0].name = this.translateService.instant(
              'lineSetter.toolRequest.table.groupFilter.all.items');
      }
  }

  onPageChange(tableConfig: TableConfig) {
      this.pageChange.emit(tableConfig);
  }

  onSortChange(tableConfig: TableConfig) {
      this.sortChange.emit(tableConfig);
  }

  onFilterChange(tableConfig: TableConfig) {
      this.filterChange.emit(tableConfig);
  }

  onFilterGroupChange(tableConfig: TableConfig) {
      for (const filter of this.tableConfig.filters) {
          if (filter.field === 'equipmentId') {
              this.groupFilters[0].selectedValue = filter.value;
          }
          if (filter.field === 'partNumberId') {
              this.groupFilters[1].selectedValue = filter.value;
          }
      }
      this.filterGroupChange.emit(tableConfig);
  }

  onGroupChange(tableConfig: TableConfig) {
      this.groupChange.emit(tableConfig);
  }

  isToolSet(record) {
      return record instanceof ToolSet;
  }

  getSetForTool(tool: Tool): ToolSet | null {
    for (const el of this.toolsGrouped) {
        if (el instanceof ToolSet) {
            for (const toolOfSet of el.tools) {
                 if (toolOfSet.id === tool.id) {
                      return el;
                 }
             }
         }
     }
    return null;
  }

  isToolSelected(tool: Tool | ToolSet) {
      return this.selectedTools.filter(selectedTool => (
              (selectedTool instanceof Tool && tool instanceof Tool && selectedTool.id === tool.id) ||
              (selectedTool instanceof ToolSet && tool instanceof ToolSet && selectedTool.name === tool.name)
          )
      ).length > 0;
  };

  private handleSingleToolSetSelected(toolSet: ToolSet) {
      const selectedSubtools = toolSet.tools.filter(tool => this.isToolSelected(tool));
      for (const selectedSubTool of selectedSubtools) {
          this.onToolClicked.emit({checked: false, group: selectedSubTool})
    }
  }

private handleToolChecked(selectedTool: Tool, setForSelectedTool: ToolSet) {
  if (setForSelectedTool) {
      let allChecked = true;
      for (const tool of setForSelectedTool.tools) {
          if (tool.id !== selectedTool.id && !this.isToolSelected(tool)) {
              allChecked = false;
          }
      }
      if (allChecked) {
          for (const tool of setForSelectedTool.tools) {
              if (this.isToolSelected(tool)) {
                  this.onToolClicked.emit({checked: false, group: tool});
              }
          }
          this.onToolClicked.emit({checked: true, group: setForSelectedTool});
      } else {
          this.onToolClicked.emit({checked: true, group: selectedTool});
      }
  } else {
      this.onToolClicked.emit({checked: true, group: selectedTool});
  }
}

  private handleToolUnchecked(unselectedTool: Tool, setForUnselectedTool: ToolSet) {
    if (setForUnselectedTool && this.isToolSelected(setForUnselectedTool)) {
          this.onToolClicked.emit({checked: false, group: setForUnselectedTool});
          for (const selectedTool of setForUnselectedTool.tools) {
              if (selectedTool.id !== unselectedTool.id) {
                  this.onToolClicked.emit({checked: true, group: selectedTool});
              }
          }
      } else {
          this.onToolClicked.emit({checked: false, group: unselectedTool});
      }
    }

  onClickTool(event: any, record: Tool | ToolSet) {
    event.stopPropagation();
    if (record instanceof ToolSet) {
        this.handleSingleToolSetSelected(record);
        this.onToolClicked.emit({checked: event.target.checked, group: record});
    } else if (record instanceof Tool) {
        const setForSelectedTool = this.getSetForTool(record);
        if (event.target.checked) {
            this.handleToolChecked(record, setForSelectedTool);
        } else {
            this.handleToolUnchecked(record, setForSelectedTool);
        }
    }
  }

  isSelectionDisabled(record) {
      return record.disabled;
  }

  hasCheckbox(record: any) {
      return (record instanceof Tool || record instanceof ToolSet);
  }

  toolSetContainsTool(tool: Tool, toolSet: ToolSet): boolean {
      return toolSet.tools.filter(toolFromToolSet => toolFromToolSet.id === tool.id).length > 0;
  }

  isChecked(record: Tool | ToolSet) {
      if (this.isToolSelected(record)) {
          return true;
      } else if (record instanceof Tool) {
          return this.selectedTools.filter(
              tool => tool instanceof ToolSet &&
                  this.toolSetContainsTool(record, tool)
          ).length > 0;
      }
  }
}
